<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md4>
        <v-card class="elevation-12">
          <v-toolbar dark color="blue-grey darken-1">
            <v-toolbar-title>
              <div class="nav__logo">
                <v-icon color="green" class="nav__logo-icon"
                  >mdi-cellphone-check</v-icon
                >
                Print Case
              </div>
            </v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-form>
              <v-text-field
                v-model="login"
                prepend-icon="mdi-account"
                name="login"
                label="Логин"
                type="text"
              ></v-text-field>
              <v-text-field
                v-model="password"
                id="password"
                prepend-icon="mdi-lock"
                name="password"
                label="Пароль"
                type="password"
              ></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" class="px-5" @click="loginHandler"
              >Войти</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: "Login",
  data() {
    return {
      login: "",
      password: "",
    };
  },

  methods: {
    async loginHandler() {
      const payload = {
        username: this.login,
        password: this.password,
      };

      await this.$store.dispatch("signin", payload);

      if (this.$store.state.isLoggedIn) {
        this.$router.push("/");
      }
    },
  },
};
</script>

<style></style>
